import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  const [featured, ...rest] = testimonials;
  return <section className="border-b border-line bg-sand" data-id="element-240" data-mp="1n0addghtiqw3">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-241" data-mp="1mzsaw24kbgfq">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-242" data-mp="1r0ubone4o0jt">
          <div data-id="element-243" data-mp="1d1be2oiy07lr">
            <Eyebrow data-id="element-244" data-mp="1d0t9n4m4mn2r">La eligen profes de piano y guitarra</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-245" data-mp="1i0o4fj90vwt3">
              Lo que dicen los profes
            </h2>
          </div>
          <p className="text-[13px] text-ink-mute" data-id="element-246" data-mp="143izxnoyj5zy">
            Estudios, academias y profesores particulares
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-247" data-mp="2yexr88xm9dht">
          <figure className="flex h-full flex-col rounded-2xl border border-line bg-paper p-8 shadow-card sm:p-10" data-id="element-248" data-mp="2ydcwai7e3sjf">
            <blockquote className="font-display text-2xl italic leading-snug text-ink sm:text-[28px]" data-id="element-249" data-mp="2v1koofc2ftrj">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-8" data-id="element-250" data-mp="2q27tn7b1jgdv">
              <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-ink text-sm font-semibold text-cream" data-id="element-251" data-mp="34qcfgk5e480v">
                {featured.initials}
              </span>
              <span data-id="element-252" data-mp="273n8rwzqt78o">
                <span className="block text-sm font-semibold text-ink" data-id="element-253" data-mp="274f2115vasvs">{featured.name}</span>
                <span className="block text-[13px] text-ink-mute" data-id="element-254" data-mp="2m1fksf62zdi4">{featured.role}</span>
              </span>
            </figcaption>
          </figure>

          <ul className="grid gap-4" data-id="element-255" data-mp="2h0i3e4swanho">
            {rest.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-line bg-paper px-6 py-5" data-id="element-256" data-mp="19ccfxqcinjz">
                <blockquote className="text-[15px] leading-relaxed text-ink-soft" data-id="element-257" data-mp="3f0vnntai2xj">
                  “{item.quote}”
                </blockquote>
                <div className="mt-auto flex items-center gap-3 pt-4" data-id="element-258" data-mp="8ckcmvhdgtt6">
                  <span aria-hidden="true" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sand text-[11px] font-semibold text-ink-soft" data-id="element-259" data-mp="dcorkh2mtgha">
                    {item.initials}
                  </span>
                  <span className="text-[13px] text-ink" data-id="element-260" data-mp="3lsi64qdekhvp">
                    <span className="font-semibold" data-id="element-261" data-mp="3lt1izso74g2v">{item.name}</span>
                    <span className="text-ink-mute" data-id="element-262" data-mp="3qr2xs1el9t8j"> · {item.role}</span>
                  </span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}